import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./data.scss"

const Data = () => {

    return (
        <div className="data">
            <Helmet>
                <title>Stammdaten</title>
            </Helmet>
            <div className="container">
                <div className="header">
                    <h1>Stammdaten</h1>
                </div>
                <div className="layout">
                    <div className="navigation">
                        <NavLink to="/data/users">Benutzer</NavLink>
                        <NavLink to="/data/items">Fuhrpark</NavLink>
                        <NavLink to="/data/team">Team</NavLink>
                        <NavLink to="/data/tracker">Tracker</NavLink>
                    </div>
                    <div className="content">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Data;